import ContentBlocks, { ContentBlocksProps } from '@components/_content-page/ContentBlocks'
import { cn } from '@lib/cn'
import { FC } from 'react'

type RichExperiencePagesContentBlockProps = ContentBlocksProps & {
  showContent: boolean
}

export const RichExperiencePagesContentBlock: FC<RichExperiencePagesContentBlockProps> = ({
  showContent,
  ...rest
}) => {
  return (
    <section
      className={cn('opacity-0 transition-opacity duration-500', 'data-[show-content]:opacity-100')}
      data-show-content={showContent ? '' : undefined}
    >
      <ContentBlocks {...rest} />
    </section>
  )
}
